<template>
	<div class="platform-info-container">
		<!-- 头部操作区 -->
		<div class="header-section" v-if="!showFlag">
			<div class="page-title">
				<div class="title-icon">
					<svg viewBox="0 0 24 24">
						<path d="M13,3V9H21V3M13,21H21V11H13M3,21H11V15H3M3,13H11V3H3V13Z"/>
					</svg>
				</div>
				<div class="title-content">
				<h2>平台信息管理</h2>
				<p>管理平台基本信息和用户注册协议</p>
				</div>
			</div>
			<div class="header-actions">
				<el-button type="primary" icon="el-icon-plus" @click="addOrUpdateHandler()" class="add-btn">
					新增信息
				</el-button>
				<el-button icon="el-icon-refresh" @click="getDataList" class="refresh-btn">
					刷新
				</el-button>
			</div>
		</div>

		<!-- 筛选区域 -->
		<div class="filter-section" v-if="!showFlag">
			<el-card class="filter-card" shadow="never">
				<div class="filter-header">
					<h3>筛选条件</h3>
					<el-button type="text" @click="resetSearch" class="reset-btn">
						<i class="el-icon-refresh-left"></i>
						重置
					</el-button>
				</div>
			<el-form :inline="true" class="filter-form">
				<el-form-item label="类型筛选">
						<el-select v-model="searchForm.type" placeholder="选择类型" clearable @change="getDataList" class="filter-select">
							<el-option label="平台信息" value="platform">
								<span class="option-item">
									<i class="el-icon-info"></i>
									平台信息
								</span>
							</el-option>
							<el-option label="注册协议" value="agreement">
								<span class="option-item">
									<i class="el-icon-document"></i>
									注册协议
								</span>
							</el-option>
							<el-option label="隐私政策" value="privacy">
								<span class="option-item">
									<i class="el-icon-lock"></i>
									隐私政策
								</span>
							</el-option>
							<el-option label="服务条款" value="terms">
								<span class="option-item">
									<i class="el-icon-files"></i>
									服务条款
								</span>
							</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态筛选">
						<el-select v-model="searchForm.status" placeholder="选择状态" clearable @change="getDataList" class="filter-select">
							<el-option label="启用" value="1">
								<span class="option-item">
									<i class="el-icon-check status-enabled"></i>
									启用
								</span>
							</el-option>
							<el-option label="禁用" value="0">
								<span class="option-item">
									<i class="el-icon-close status-disabled"></i>
									禁用
								</span>
							</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关键词">
					<el-input 
						v-model="searchForm.keyword" 
						placeholder="输入标题关键词" 
						clearable 
						@keyup.enter.native="getDataList"
							@clear="getDataList"
							class="keyword-input"
						>
							<i slot="prefix" class="el-input__icon el-icon-search"></i>
						</el-input>
				</el-form-item>
				<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="getDataList" class="search-btn">搜索</el-button>
				</el-form-item>
			</el-form>
			</el-card>
		</div>

    <!-- 列表页 -->
		<div v-if="!showFlag" class="table-section">
			<el-card class="table-card" shadow="never">
				<div class="table-header">
					<h3>信息列表</h3>
					<div class="table-stats">
						<span class="stat-item">
							<i class="el-icon-document"></i>
							共 {{ totalPage }} 条记录
						</span>
					</div>
				</div>
        <el-table
          :data="dataList"
				v-loading="dataListLoading"
				class="info-table"
				empty-text="暂无数据"
				element-loading-text="加载中..."
				element-loading-spinner="el-icon-loading"
        >
				<el-table-column label="序号" type="index" width="80" align="center" :index="getTableIndex">
					<template slot-scope="scope">
						<div class="index-cell">{{ getTableIndex(scope.$index) }}</div>
					</template>
				</el-table-column>

				<el-table-column prop="title" label="标题" min-width="250" show-overflow-tooltip>
					<template slot-scope="scope">
						<div class="title-cell">
							<div class="title-icon-wrapper">
								<i :class="getTypeIcon(scope.row.type)" :style="{color: getTypeColor(scope.row.type)}"></i>
							</div>
							<div class="title-content">
								<div class="title-text">{{ scope.row.title }}</div>
								<div class="title-summary" v-if="scope.row.summary">{{ scope.row.summary }}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="type" label="类型" width="120" align="center">
					<template slot-scope="scope">
						<el-tag :type="getTypeTagType(scope.row.type)" size="small" class="type-tag">
							{{ getTypeLabel(scope.row.type) }}
						</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="status" label="状态" width="100" align="center">
					<template slot-scope="scope">
						<el-switch
							v-model="scope.row.status"
							:active-value="1"
							:inactive-value="0"
							@change="handleStatusChange(scope.row)"
							class="status-switch"
						></el-switch>
						<div class="status-text">
							{{ scope.row.status === 1 ? '启用' : '禁用' }}
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="sort" label="排序" width="80" align="center">
					<template slot-scope="scope">
						<span class="sort-value">{{ scope.row.sort || 0 }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="updateTime" label="更新时间" width="160" align="center">
            <template slot-scope="scope">
						<div class="time-cell">
							<i class="el-icon-time"></i>
							<span>{{ formatTime(scope.row.updateTime) }}</span>
						</div>
            </template>
          </el-table-column>

				<el-table-column label="操作" width="240" align="center" fixed="right">
            <template slot-scope="scope">
							<div class="action-buttons">
              <el-button
                type="text"
							size="small"
							icon="el-icon-view"
							@click="viewHandler(scope.row)"
							class="action-btn view-btn"
						>查看</el-button>
						<el-button
							type="text"
                size="small"
							icon="el-icon-edit"
                @click="addOrUpdateHandler(scope.row)"
							class="action-btn edit-btn"
						>编辑</el-button>
						<el-button
							type="text"
							size="small"
							icon="el-icon-delete"
							@click="deleteHandler(scope.row.id)"
							class="action-btn delete-btn"
						>删除</el-button>
						</div>
            </template>
          </el-table-column>
        </el-table>
		
			<!-- 分页 -->
			<div class="pagination-section">
        <el-pagination
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
					layout="total, sizes, prev, pager, next, jumper"
					background
					class="pagination"
        ></el-pagination>
      </div>
			</el-card>
    </div>

		<!-- 添加/修改页面 -->
    <add-or-update v-else :parent="this" ref="addOrUpdate"></add-or-update>
  </div>
</template>
<script>
import AddOrUpdate from "./chat-add-or-update";

export default {
  data() {
    return {
			searchForm: {
				type: '',
				status: '',
				keyword: ''
			},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      showFlag: false,
			dataListSelections: []
    };
  },
	
  created() {
		this.getDataList();
	},
	
  components: {
    AddOrUpdate
  },
	
  methods: {
		// 获取数据列表
    getDataList() {
      this.dataListLoading = true;
			const params = {
          page: this.pageIndex,
          limit: this.pageSize,
				sortField: 'updateTime',  // 使用sortField而不是sort避免冲突
				sortOrder: 'desc'
			};
			
			// 添加搜索条件
			if (this.searchForm.type) {
				params.type = this.searchForm.type;
			}
			if (this.searchForm.status !== '') {
				params.status = this.searchForm.status;
			}
			if (this.searchForm.keyword) {
				params.keyword = this.searchForm.keyword;
			}

			this.$http({
				url: "/chat/page",
				method: "get",
				params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
					this.dataList = data.data.list || [];
					this.totalPage = data.data.total || 0;
        } else {
					this.$message.error(data.msg || '获取数据失败');
					this.dataList = [];
					this.totalPage = 0;
        }
        this.dataListLoading = false;
			}).catch((error) => {
				console.error('获取数据失败:', error);
				this.$message.error('网络请求失败，请检查网络连接');
				this.dataList = [];
				this.totalPage = 0;
				this.dataListLoading = false;
      });
		},

		// 重置搜索
		resetSearch() {
			this.searchForm = {
				type: '',
				status: '',
				keyword: ''
			};
			this.pageIndex = 1;
			this.getDataList();
		},

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },

    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

		// 添加/编辑
    addOrUpdateHandler(row) {
      this.showFlag = true;
      this.$nextTick(() => {
				this.$refs.addOrUpdate.init(row ? row.id : null);
			});
		},

		// 查看详情
		viewHandler(row) {
			this.$alert(row.content || '暂无内容', row.title, {
				confirmButtonText: '确定',
				customClass: 'content-dialog',
				dangerouslyUseHTMLString: false
			});
		},

		// 删除
		deleteHandler(id) {
			this.$confirm('此操作将永久删除该信息，是否继续？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: "/chat/delete",
					method: "post",
					data: [id]
				}).then(({ data }) => {
					if (data && data.code === 0) {
						this.$message.success('删除成功');
						this.getDataList();
					} else {
						this.$message.error(data.msg || '删除失败');
					}
				}).catch((error) => {
					console.error('删除失败:', error);
					this.$message.error('删除失败，请稍后重试');
				});
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},

		// 状态切换
		handleStatusChange(row) {
			const status = row.status ? '启用' : '禁用';
			this.$confirm(`确定要${status}该信息吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
			this.$http({
					url: "/chat/updateStatus",
					method: "post",
					data: { 
						id: row.id, 
						status: row.status 
					}
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.$message.success(`${status}成功`);
				} else {
						this.$message.error(data.msg || `${status}失败`);
						// 恢复原状态
						row.status = row.status === 1 ? 0 : 1;
					}
				}).catch((error) => {
					console.error(`${status}失败:`, error);
					this.$message.error(`${status}失败，请稍后重试`);
					// 恢复原状态
					row.status = row.status === 1 ? 0 : 1;
				});
			}).catch(() => {
				// 用户取消，恢复原状态
				row.status = row.status === 1 ? 0 : 1;
			});
		},

		// 获取类型标签样式
		getTypeTagType(type) {
			const typeMap = {
				'platform': 'primary',
				'agreement': 'success',
				'privacy': 'warning',
				'terms': 'info'
			};
			return typeMap[type] || 'info';
		},

		// 获取类型标签文本
		getTypeLabel(type) {
			const typeMap = {
				'platform': '平台信息',
				'agreement': '注册协议',
				'privacy': '隐私政策',
				'terms': '服务条款'
			};
			return typeMap[type] || '未知类型';
		},

		// 获取类型图标
		getTypeIcon(type) {
			const iconMap = {
				'platform': 'el-icon-info',
				'agreement': 'el-icon-document',
				'privacy': 'el-icon-lock',
				'terms': 'el-icon-files'
			};
			return iconMap[type] || 'el-icon-info';
		},

		// 获取类型图标颜色
		getTypeColor(type) {
			const colorMap = {
				'platform': '#409EFF', // 蓝色
				'agreement': '#67C23A', // 绿色
				'privacy': '#E6A23C', // 橙色
				'terms': '#909399' // 灰色
			};
			return colorMap[type] || '#909399';
		},

		// 获取表格序号
		getTableIndex(index) {
			return (this.pageIndex - 1) * this.pageSize + index + 1;
		},

		// 格式化时间
		formatTime(time) {
			if (!time) return '--';
			const date = new Date(time);
			return date.toLocaleDateString('zh-CN', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.platform-info-container {
	padding: 24px;
	background: #f8fafc;
	min-height: 100vh;
}
	
// 头部区域
.header-section {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 24px;
	padding: 24px;
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	.page-title {
		display: flex;
		align-items: center;
		margin-bottom: 16px;

		.title-icon {
			width: 40px;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: #409EFF;
			border-radius: 8px;
			margin-right: 16px;

			svg {
				width: 24px;
				height: 24px;
				fill: white;
			}
		}

		.title-content {
		h2 {
			font-size: 24px;
			font-weight: 600;
			color: #1a202c;
			margin: 0 0 8px 0;
		}

		p {
			color: #718096;
			font-size: 14px;
			margin: 0;
		}
	}

	.header-actions {
		display: flex;
		gap: 12px;
		}
	}
}

// 筛选区域
.filter-section {
	margin-bottom: 24px;
	padding: 20px;
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	.filter-card {
		.filter-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;

			h3 {
				font-size: 18px;
				font-weight: 600;
				color: #2d3748;
				margin: 0;
			}

			.reset-btn {
				color: #4299e1;
				font-size: 14px;

				&:hover {
					color: #3182ce;
				}
			}
		}

	.filter-form {
		:deep(.el-form-item) {
			margin-bottom: 0;
			margin-right: 20px;

			.el-form-item__label {
				font-weight: 500;
				color: #4a5568;
				}

				.filter-select {
					.option-item {
						display: flex;
						align-items: center;
						gap: 8px;
						font-size: 14px;
						color: #4a5568;

						.el-icon-info, .el-icon-document, .el-icon-lock, .el-icon-files {
							font-size: 16px;
						}
					}
				}

				.keyword-input {
					.el-input__icon {
						font-size: 16px;
					}
				}

				.search-btn {
					background-color: #4299e1;
					border-color: #4299e1;

					&:hover {
						background-color: #3182ce;
						border-color: #3182ce;
					}
				}
			}
		}
	}
}

// 表格区域
.table-section {
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	overflow: hidden;

	.table-card {
		.table-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;

			h3 {
				font-size: 18px;
				font-weight: 600;
				color: #2d3748;
				margin: 0;
			}

			.table-stats {
				font-size: 14px;
				color: #718096;

				.stat-item {
					display: flex;
					align-items: center;
					gap: 8px;

					.el-icon-document {
						font-size: 16px;
						color: #4299e1;
					}
				}
			}
		}

	.info-table {
		:deep(.el-table__header) {
			th {
				background: #f7fafc;
				color: #2d3748;
				font-weight: 600;
				padding: 16px 0;
			}
		}

		:deep(.el-table__body) {
			tr {
				&:hover {
					background: #f7fafc;
			}
	
				td {
					padding: 16px 0;
					border-bottom: 1px solid #e2e8f0;
			}
			}
		}
		
		.title-cell {
				display: flex;
				align-items: center;
				gap: 12px;
				padding-left: 10px;

				.title-icon-wrapper {
					width: 32px;
					height: 32px;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: #ebf8ff;
					border-radius: 6px;

					.el-icon-info, .el-icon-document, .el-icon-lock, .el-icon-files {
						font-size: 20px;
					}
				}

				.title-content {
			.title-text {
				font-weight: 500;
				color: #2d3748;
						font-size: 16px;
					}

					.title-summary {
						font-size: 13px;
						color: #718096;
						margin-top: 4px;
					}
				}
		}

			.type-tag {
				font-size: 13px;
				font-weight: 500;
			}

			.status-switch {
				:deep(.el-switch__core) {
					width: 50px !important;
				}
			}
			
			.status-text {
				font-size: 12px;
				color: #606266;
				margin-top: 4px;
				font-weight: 500;
			}

			.sort-value {
				font-size: 14px;
				color: #4a5568;
			}

			.time-cell {
				display: flex;
				align-items: center;
				gap: 8px;
				font-size: 14px;
				color: #718096;

				.el-icon-time {
					font-size: 16px;
				}
			}

			.action-buttons {
				display: flex;
				gap: 12px;

				.action-btn {
					padding: 0;
					height: auto;
					line-height: 1;

					&.view-btn {
						color: #4299e1;

						&:hover {
							color: #3182ce;
						}
					}

					&.edit-btn {
						color: #67c23a;

						&:hover {
							color: #51961d;
						}
					}

					&.delete-btn {
						color: #f56c6c;

			&:hover {
							color: #e64747;
						}
					}
				}
			}
		}
	}
}

// 分页区域
.pagination-section {
	padding: 20px;
	display: flex;
	justify-content: center;
	background: white;
	border-top: 1px solid #e2e8f0;
			}
	
// 内容对话框样式
:deep(.content-dialog) {
	.el-message-box__content {
		max-height: 400px;
		overflow-y: auto;
		text-align: left;
			}
}

// 响应式设计
@media (max-width: 1200px) {
	.platform-info-container {
		padding: 16px;
	}

	.header-section {
		flex-direction: column;
		gap: 16px;
		align-items: stretch;

		.header-actions {
			justify-content: flex-start;
		}
			}
	
	.filter-section {
		.filter-card {
			.filter-header {
				flex-direction: column;
				align-items: flex-start;
				gap: 12px;
			}
		.filter-form {
			:deep(.el-form-item) {
				margin-right: 16px;
				margin-bottom: 16px;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.platform-info-container {
		padding: 12px;
	}

	.header-section,
	.filter-section {
		padding: 16px;
		margin-bottom: 16px;
	}

	.filter-section {
		.filter-card {
			.filter-header {
				flex-direction: column;
				align-items: flex-start;
				gap: 12px;
			}
		.filter-form {
			:deep(.el-form-item) {
				display: block;
				margin-right: 0;
				margin-bottom: 12px;

				.el-form-item__content {
					margin-left: 0 !important;
					}
				}
			}
		}
			}
	
	.table-section {
		.table-card {
			.table-header {
				flex-direction: column;
				align-items: flex-start;
				gap: 12px;
			}
		.info-table {
			:deep(.el-table__body) {
				tr td {
					padding: 12px 0;
					}
				}
			}
		}
	}

	.pagination-section {
		padding: 16px;
			}
}

@media (max-width: 480px) {
	.header-section {
		.page-title h2 {
			font-size: 20px;
		}
			}
	
	.header-actions {
		flex-direction: column;
		gap: 8px;

		.el-button {
			width: 100%;
		}
			}
	
	.table-section {
		overflow-x: auto;

		.info-table {
			min-width: 800px;
		}
	}
			}
</style>

